import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { useAxiosDiagnosis } from "./axios";

export const useDeleteFtDiagnosis = () => {
  const [state, execute, cancel] = useAxiosDiagnosis<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (diagnosisId: ObjectId) =>
      execute({
        url: `/ft/${diagnosisId}`,
      }),
    [execute]
  );

  return [state, callback, cancel] as const;
};
